export const commercialsCampaigns = ['Campanha Hot Lead', 'Daniela', 'Brenda', 'Visibilit'];
export const billingsCampaigns = ['Campanha Cold Lead', 'Caroline'];
export const implantationsCampaigns = ['Campanha Esporádico', 'Ingrid'];

// Cada pausa de campanha guarda o cliente atual na sua própria chave, para que ao
// trocar de campanha o cliente da campanha anterior não seja reaproveitado.
export const campaignStorageKeys = {
    'Campanha Hot Lead': 'campaignClientHotLead',
    'Daniela': 'campaignClientDaniela',
    'Brenda': 'campaignClientBrenda',
    'Visibilit': 'campaignClientVisibilit',
    'Campanha Cold Lead': 'campaignClientColdLead',
    'Caroline': 'campaignClientCaroline',
    'Campanha Esporádico': 'campaignClientEsporadico',
    'Ingrid': 'campaignClientIngrid',
};

export const getCampaignStorageKey = (pause, fallback) => campaignStorageKeys[pause] || fallback;
